// ServiceCard.js
import React, { useEffect, useState } from "react";
import { Col, Card, Spinner } from "react-bootstrap";
import { useData } from "../../providers/dataProvider";

export default function ServiceCard({ service }) {
  const { title, description, image_id } = service;
  const { images, imagesLoading } = useData();

  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getImageUrl = async () => {
      if (image_id) {
        setLoading(true);
        try {
          const image = images.find((i) => i.id === image_id);
          setImageUrl(image.aws_location);
        } catch (error) {
          console.error("Error loading image:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    getImageUrl();
  }, [image_id, images]);

  if (loading || imagesLoading || !imageUrl) {
    return (
      <Col xs={12} sm={6} md={4} lg={4} xl={3} className="mb-4">
        <Card className="h-100 border-0 shadow-sm bg-dark text-white service-card">
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "200px" }}
          >
            <Spinner animation="border" />
          </div>
        </Card>
      </Col>
    );
  }

  return (
    <Col xs={12} sm={6} md={4} lg={4} xl={3} className="mb-4">
      <Card
        className="h-100 border-0 shadow-sm bg-dark text-white service-card"
        style={{ width: "100%" }}
      >
        <div className="overflow-hidden" style={{ height: "200px" }}>
          <Card.Img
            variant="top"
            src={imageUrl}
            alt={title}
            className="img-fluid"
            style={{ objectFit: "contain", height: "100%", width: "100%" }}
          />
        </div>
        <Card.Body className="d-flex flex-column">
          <Card.Title>{title}</Card.Title>
          <Card.Text>{description}</Card.Text>
        </Card.Body>
      </Card>
    </Col>
  );
}
